import React from 'react';

const ActivateProfile = ({ toggleSuspension }) => (
  <a onClick={toggleSuspension}>activate profile</a>
)

const SuspendProfile = ({ toggleSuspension }) => (
  <a onClick={toggleSuspension}>suspend profile</a>
)

const SuspendProfileToggle = ({ suspended, toggleSuspension }) => {
  const Component =suspended ? ActivateProfile : SuspendProfile

  return(<Component toggleSuspension={toggleSuspension} />)
}

export default SuspendProfileToggle



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/SuspendProfileToggle.js